import { observer } from 'mobx-react-lite'
import { DropdownGroup, DropdownTextInput, type IDropdownItem, Scrollbar } from 'shared/ui'
import styles from './styles.module.scss'

type ILinkDropdownCustomComponentProps = {
  search: string
  setSearch: (value: string) => void
  itemsList: IDropdownItem[]
  setItem: (item: IDropdownItem) => void
  onClose: () => void
  removeError: () => void
}

export const LinkDropdownCustomComponent = observer(
  ({
    search,
    setSearch,
    itemsList,
    setItem,
    onClose,
    removeError,
  }: ILinkDropdownCustomComponentProps) => {
    return (
      <>
        <DropdownTextInput
          textFieldProps={{
            value: search,
            onChange: setSearch,
            InputProps: {
              placeholder: 'Search',
            },
          }}
          ariaLabel='searchLinks'
        />
        <Scrollbar autoHeight autoHeightMax={134}>
          {itemsList.length ? (
            <DropdownGroup
              items={itemsList}
              onChange={(item) => {
                setItem?.(item)
                removeError()
                onClose()
              }}
              stylesWrap={{
                padding: '4px',
              }}
              isScroll={false}
            />
          ) : (
            <div className={styles.noResult}>No results found</div>
          )}
        </Scrollbar>
      </>
    )
  }
)
